import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';
import daycareImage from '../../../../public/img/first-view-image6.webp';
import Logo from '../../../../public/img/logo.svg';
import monteChatHeroImage from '../../../../public/img/monte-chat-hero-image.webp';
import { PageUrl } from '../../../constants/PageUrl';
import styles from './index.module.scss';

export const FirstView = () => (
  <>
    <div className={styles['sp-only']}>
      <FirstViewSp />
    </div>
    <div className={styles['pc-only']}>
      <FirstViewPc />
    </div>
  </>
);

type LinkTitleProps = {
  title: string;
};

const LinkTitle = ({ title }: LinkTitleProps) => <div className={styles['link-title']}>{title}</div>;

const FirstViewSp = () => (
  <div className={styles['sp-root']}>
    <Link key={PageUrl.DAYCARE_TOP} href={PageUrl.DAYCARE_TOP} className={styles.link}>
      <div className={styles['image-wrapper']}>
        <LinkTitle title="モンテッソーリ保育園" />
        <ExportedImage
          priority
          fill
          src={daycareImage}
          className={styles['daycare-image']}
          alt="保育園のイメージ画像"
          style={{ objectFit: 'cover' }}
        />
      </div>
    </Link>
    <div className={styles['logo-wrapper']}>
      <Logo />
    </div>
    <Link key={PageUrl.MONTE_CHAT_ROOT} href={PageUrl.MONTE_CHAT_ROOT} className={styles.link}>
      <div className={styles['monte-chat-image-wrapper']}>
        <LinkTitle title="モンテチャット" />
        <ExportedImage
          priority
          fill
          src={monteChatHeroImage}
          className={styles['monte-chat-image']}
          alt="モンテチャットの利用イメージ"
        />
      </div>
    </Link>
  </div>
);

const FirstViewPc = () => (
  <div className={styles['pc-root']}>
    <div className={styles['logo-wrapper']}>
      <Logo />
    </div>
    <div className={styles['images-row']}>
      <Link href={PageUrl.DAYCARE_TOP} className={styles['pc-link']}>
        <div className={styles['image-wrapper']}>
          <LinkTitle title="モンテッソーリ保育園" />
          <ExportedImage
            priority
            fill
            src={daycareImage}
            className={styles['daycare-image']}
            alt="保育園のイメージ画像"
            style={{ objectFit: 'cover' }}
          />
        </div>
      </Link>
      <Link href={PageUrl.MONTE_CHAT_ROOT} className={styles['pc-link']}>
        <div className={styles['monte-chat-image-wrapper']}>
          <LinkTitle title="モンテチャット" />
          <ExportedImage
            priority
            fill
            src={monteChatHeroImage}
            className={styles['monte-chat-image']}
            alt="モンテチャットの利用イメージ"
          />
        </div>
      </Link>
    </div>
  </div>
);
